module.exports = __webpack_public_path__ + "static/media/v0_ai.cff5f111.png";